import { render } from "./RecommendList.vue?vue&type=template&id=c0a3a9ec&scoped=true"
import script from "./RecommendList.vue?vue&type=script&lang=js"
export * from "./RecommendList.vue?vue&type=script&lang=js"

import "./RecommendList.vue?vue&type=style&index=0&id=c0a3a9ec&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0a3a9ec"]])

export default __exports__